export const JEWELRY_DISPLAY = [
    {
      item: 'Inaya Jewelry Display ',
      itemImageDesktop: '/images/packaging/jewelryDisplay/desktop/inaya.webp',
      //itemImageMobile: '/images/packaging/jewelryDisplay/mobile/inaya.webp',
      path: '/packaging/jewelry-displays/inaya',
    },
    {
      item: 'Livia Jewelry Display ',
      itemImageDesktop: '/images/packaging/jewelryDisplay/desktop/livia.webp',
      //itemImageMobile: '/images/packaging/jewelryDisplay/mobile/livia.webp',
      path: '/packaging/jewelry-displays/livia',
    },
    {
      item: 'Gaia Jewelry Display ',
      itemImageDesktop: '/images/packaging/jewelryDisplay/desktop/gaia.webp',
      //itemImageMobile: '/images/packaging/jewelryDisplay/mobile/gaia.webp',
      path: '/packaging/jewelry-displays/gaia',
    },
    {
      item: 'Irene Jewelry Display ',
      itemImageDesktop: '/images/packaging/jewelryDisplay/desktop/irene.webp',
      //itemImageMobile: '/images/packaging/jewelryDisplay/mobile/irene.webp',
      path: '/packaging/jewelry-displays/irene',
    },
    {
      item: 'Bambino Jewelry Display ',
      itemImageDesktop: '/images/packaging/jewelryDisplay/desktop/bambino.webp',
      //itemImageMobile: '/images/packaging/jewelryDisplay/mobile/bambino.webp',
      path: '/packaging/jewelry-displays/bambino',
    },
    {
      item: 'Doice Jewelry Display ',
      itemImageDesktop: '/images/packaging/jewelryDisplay/desktop/doice.webp',
      //itemImageMobile: '/images/packaging/jewelryDisplay/mobile/doice.webp',
      path: '/packaging/jewelry-displays/doice',
    },
    {
      item: 'Silvia Jewelry Display ',
      itemImageDesktop: '/images/packaging/jewelryDisplay/desktop/silvia.webp',
      //itemImageMobile: '/images/packaging/jewelryDisplay/mobile/silvia.webp',
      path: '/packaging/jewelry-displays/silvia',
    },
    {
      item: 'Rosa Jewelry Display ',
      itemImageDesktop: '/images/packaging/jewelryDisplay/desktop/rosa.webp',
      //itemImageMobile: '/images/packaging/jewelryDisplay/mobile/rosa.webp',
      path: '/packaging/jewelry-displays/rosa',
    },
    {
      item: 'Martina Jewelry Display ',
      itemImageDesktop: '/images/packaging/jewelryDisplay/desktop/martina.webp',
      //itemImageMobile: '/images/packaging/jewelryDisplay/mobile/martina.webp',
      path: '/packaging/jewelry-displays/martina',
    },

  ]